import { gql } from 'react-apollo';

export const getSubmittedBarriers = gql`
  query getSubmittedBarriers($churchId: Int!) {
    statistics {
      churchManager: church_manager {
        church(church_id: $churchId) {
          submittedBarriers: submitted_barriers {
            totalBarriers: total_barriers
            barriers {
              barrier {
                id
                name
              }
              total
            }
            otherBarriers: other_barriers {
              barrierText: other_barrier_text
              updatedAt: other_barrier_updated_at
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/barriers/queries/getSubmittedBarriers.js